import React, { useEffect, useMemo, useRef, useState } from 'react';
import { IReactionDisposer, autorun } from 'mobx';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import _ from 'lodash';
import dayjs from 'dayjs';
import { Carousel, Loading, Empty } from '@tencent/spaui';
import { Link, useHistory } from 'react-router-dom';
import deskAnnouncementSercice from './services/desk-announcement';
import noticeStore from './store/index';
import OverflowHoverTip from '@/common-components/overflow-hover-tip';

import './less/desk-anno.scoped.less';

// 公告内容区域
export const DeskAnnouncementContent: React.FC<{ size?: 'normal' | 'mini' }> = observer((props) => {
  const { size = 'normal' } = props;
  const [loading, setLoading] = useState(true);
  const [pictureSelected, setPictureSelected] = useState(0);

  const history = useHistory();

  const noticeChangeUnsubscribeRef = useRef<IReactionDisposer | null>(null);

  useEffect(() => {
    // 加载数据
    deskAnnouncementSercice.initData().then(() => {
      setLoading(false);
      deskAnnouncementSercice.setOrder();
    });
    // 监听通知数据更改
    noticeChangeUnsubscribeRef.current = autorun(() => {
      if (noticeStore.noticeReadedId) {
        deskAnnouncementSercice.noticeReadedMark(noticeStore.noticeReadedId);
      }
    });

    return () => {
      deskAnnouncementSercice.clearTimer();
      if (noticeChangeUnsubscribeRef.current) {
        noticeChangeUnsubscribeRef.current();
      }
    };
  }, []);

  const noticeDataWithPicture = noticeStore.deskAnnouncementStore.autoSizedNoticeDataWithPicture;
  let noticeDataWithoutPicture = noticeStore.deskAnnouncementStore.autoSizedNoticeDataWithoutPicture;
  if (size === 'mini') {
    noticeDataWithoutPicture = noticeDataWithoutPicture.slice(0, 2);
  }

  const pictrueData = useMemo(() => {
    return noticeDataWithPicture.map((item) => {
      return {
        value: item.home_page_picture?.url,
        data: item,
      };
    });
  }, [noticeDataWithPicture]);

  return <div className={classnames('desk-card-annoucement-content', size)}>
    {loading ? (
      <div className="empty-inner">
        <Loading />
      </div>
    ) : !_.isEmpty(noticeDataWithPicture) || !_.isEmpty(noticeDataWithoutPicture) ? (
      <>
        {/* 图片区域 */}
        {/* {_.isEmpty(noticeDataWithPicture) ? null : (
          <div className="picture-slider">
            <Carousel
              data={pictrueData}
              value={pictureSelected}
              onChange={(e, v) => {
                setPictureSelected(v);
              }}
              onClickItem={(e, { data }) => {
                deskAnnouncementSercice.handleNoticeClick(data.id, data.is_read, data.title);
                history.push(`/agency/notice/${data.id}`);
              }}
              autoPlay={true}
              style={({
                '--spaui-carousel-height': '180px',
              })}
            />
          </div>
        )} */}

        {/* 文字区域 */}
        {_.isEmpty(noticeDataWithoutPicture) ? null : (
          <div className="annouce-slider">
            <ul className="slider-stage" ref={(slider) => {
              noticeStore.deskAnnouncementStore.slider = slider as any;
            }}>
              <li key={0} className={classnames({ active: true }, 'slider-list')} data-index={0}>
                {
                  <ul>
                    {noticeDataWithoutPicture.map((item) => {
                      return (
                        <div key={item.id} className={classnames({ unreaded: !item.is_read }, 'slider-item')}>
                          <OverflowHoverTip tip={item.title} style={{ flex: 1 }}>
                            <Link to={{ pathname: `/agency/notice/${item.id}` }} onClick={() => deskAnnouncementSercice.handleNoticeClick(item.id, item.is_read, item.title)}>
                              <span data-computed-dom className="slider-item-title">
                                {item.title}
                              </span>
                            </Link>
                          </OverflowHoverTip>
                          <div className="slider-item-date">{dayjs(item.valid_begin_time).format('MM-DD')}</div>
                        </div>
                      );
                    })}
                  </ul>
                }
              </li>
            </ul>
          </div>
        )}
        {/* <ul className="annouce-dots" ref={(dots) => (this.dots = dots)}>
        {noticeDataWithoutPicture.map((item, i) => (
          <li key={i} className={classnames({ active: i === now })} onClick={() => deskAnnouncementSercice.animateHandle(i)}></li>
        ))}
      </ul> */}
      </>
    ) : (
      <div className="empty-inner">
        <Empty
          size="small"
          title="暂无公告"
          showIcon={size !== 'mini'}
        />
      </div>
    )}
  </div>;
});
